import { render } from "./Layout.vue?vue&type=template&id=1cc2d5d4&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=1cc2d5d4&lang=css"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__